import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

interface SimpleAuthLayoutProps {
  children?: ReactNode;
}

const SimpleAuthLayout: React.FC<SimpleAuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4 py-8 overflow-y-auto">
      <div className="w-full max-w-md mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
        <div className="text-center p-6 border-b border-gray-200 dark:border-gray-700">
          <h1 className="text-3xl font-bold text-primary">Marune</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Track your martial arts journey</p>
        </div>
        {children || <Outlet />}
      </div>
    </div>
  );
};

export default SimpleAuthLayout;